
// Unfortunately, only available products could be added to the selection.
export const MUSTERDEPOT_NOT_ALL_ASSETS_AVAILABLE = 'Leider konnten nur verfügbare Produkte zur Auswahl hinzugefügt werden.'

// The muster depot has been added to the product selector.
export const MUSTERDEPOT_ALL_ASSETS_AVAILABLE = 'Das Musterdepot wurde der Produktauswahl hinzugefügt.'
